export { SearchBackground } from './SearchBackground'
